import http from "utils/httpRequest/http";
export const uploadCategoryImage = (categoryId = "", formData) => {
  return http.post(`/categories/${categoryId}`, formData);
};
